import dayjs from "dayjs";
import { PapaMamaPlus, SexFlug } from "../../../assets/data/Constants";

// 出生日、育児休業開始日、育児休業終了（予定）日の必須チェック
function requiredCheckError(inputDataList: any[]): boolean {
  if (inputDataList.length === 0) {
    return true;
  }
  let checkResult = false;
  inputDataList.forEach((obj) => {
    const keysToCheck = Object.keys(obj).filter(
      (key) =>
        key.startsWith("birthday") ||
        key.startsWith("startDate") ||
        key.startsWith("endDate") ||
        key.startsWith("papaMamaPlus")
    );

    const missingValues = keysToCheck.filter(
      (key) => obj[key] === undefined || obj[key] === null || obj[key] === ""
    );
    if (missingValues.length > 0) {
      checkResult = true;
    }
  });
  return checkResult;
}

// 出生日は退職（予定）日よりも後の日付チェック
function checkBirthdayLaterThanRetireDate(
  inputDataList: any[],
  retireDate: string | undefined
): boolean {
  if (
    retireDate === undefined ||
    retireDate === null ||
    retireDate.trim().length === 0
  ) {
    return false;
  }
  let checkResult = false;
  inputDataList.forEach((obj) => {
    const keysToCheck = Object.keys(obj).filter((key) =>
      key.startsWith("birthday")
    );

    keysToCheck.forEach((key) => {
      const birthday = obj[key];
      if (
        dayjs(birthday, "YYYY/MM/DD").isAfter(dayjs(retireDate, "YYYY/MM/DD"))
      ) {
        checkResult = true;
      }
    });
  });
  return checkResult;
}

// 育児休業終了（予定）日は退職（予定）日よりも後の日付チェック
// 入出力項目 初期表示レスポンス.退職（予定）日※ ＜ 育児休業終了（予定）日
// ※初期表示時にAPI呼出ししていない場合は、持回情報を参照
function checkEndDateLaterThanRetireDate(
  inputDataList: any[],
  retireDate: string | undefined
): boolean {
  if (
    retireDate === undefined ||
    retireDate === null ||
    retireDate.trim().length === 0
  ) {
    return false;
  }
  let checkResult = false;
  inputDataList.forEach((obj) => {
    const keysToCheck = Object.keys(obj).filter((key) =>
      key.startsWith("endDate")
    );

    keysToCheck.forEach((key) => {
      const endDate = obj[key];
      if (
        dayjs(endDate, "YYYY/MM/DD").isAfter(dayjs(retireDate, "YYYY/MM/DD"))
      ) {
        checkResult = true;
      }
    });
  });
  return checkResult;
}

// 未来の出生日チェック
function checkFutureBirthDate(inputDataList: any[]): boolean {
  let checkResult = false;
  inputDataList.forEach((obj) => {
    Object.keys(obj)
      .filter((key) => key.startsWith("birthday"))
      .forEach((key) => {
        const birthday = obj[key];
        if (dayjs(birthday, "YYYY/MM/DD").isAfter(dayjs())) {
          checkResult = true;
        }
      });
  });
  return checkResult;
}

// 育児休業開始日は加入日よりも前チェック
function checkStartDateBeforeContractDate(
  inputDataList: any[],
  contractDate: string | undefined
): boolean {
  if (
    contractDate === undefined ||
    contractDate === null ||
    contractDate.trim().length === 0
  ) {
    return true;
  }
  let checkResult = false;
  inputDataList.forEach((obj) => {
    Object.keys(obj)
      .filter((key) => key.startsWith("startDate"))
      .forEach((key) => {
        const startDate = obj[key];
        if (
          dayjs(startDate, "YYYY/MM/DD").isBefore(
            dayjs(contractDate, "YYYY/MM/DD")
          )
        ) {
          checkResult = true;
        }
      });
  });
  return checkResult;
}

// 半年延長の理由が「無」で、かつパパママ育休プラスが未選択の場合に、育児休業終了（予定）日が出生日の1年後以降の日付チェック
function checkNoReasonPapaMamaPlusNotSelectedOneYearAfterBirthday(
  inputDataList: any[]
): boolean {
  let checkResult = false;
  inputDataList.forEach((obj) => {
    Object.keys(obj).forEach((key) => {
      if (key.startsWith("birthday") && obj[key]) {
        const endDateKey = `endDate`;
        const papaMamaPlusKey = `papaMamaPlus`;
        const halfyearExtensionReasonKey = `halfyearExtensionReason`;

        const birthday = dayjs(obj[key], "YYYY/MM/DD");
        const endDate = dayjs(obj[endDateKey], "YYYY/MM/DD");
        const oneYearLater = birthday.add(1, "year");

        if (
          !obj[halfyearExtensionReasonKey] &&
          obj[papaMamaPlusKey] === PapaMamaPlus["無"] &&
          !oneYearLater.isAfter(endDate)
        ) {
          checkResult = true;
        }
      }
    });
  });
  return checkResult;
}

// 半年延長の理由が「有」の場合に、育児休業終了日が出生日の２年を超える日付チェック
function checkHasReasonEndDateTwoYearsLaterAfterBirthday(
  inputDataList: any[]
): boolean {
  let checkResult = false;
  inputDataList.forEach((obj) => {
    Object.keys(obj).forEach((key) => {
      if (key.startsWith("birthday") && obj[key]) {
        const endDateKey = `endDate`;
        const halfyearExtensionReasonKey = `halfyearExtensionReason`;

        const birthday = dayjs(obj[key], "YYYY/MM/DD");
        const endDate = dayjs(obj[endDateKey], "YYYY/MM/DD");
        const twoYearsLater = birthday.add(2, "year");
        if (
          ["1", "2"].includes(obj[halfyearExtensionReasonKey]) &&
          twoYearsLater.isBefore(endDate)
        ) {
          checkResult = true;
        }
      }
    });
  });
  return checkResult;
}

// パパママ育休プラスが「有」の場合に、育児休業終了（予定）日が出生日の１年２か月後を超える日付チェック
function checkHasPapaMamaPlusEndDateOneYearTwoMonthsLaterAfterBirthday(
  inputDataList: any[]
): boolean {
  let checkResult = false;
  inputDataList.forEach((obj) => {
    Object.keys(obj).forEach((key) => {
      if (key.startsWith("birthday") && obj[key]) {
        const endDateKey = `endDate`;
        const papaMamaPlusKey = `papaMamaPlus`;

        const birthday = dayjs(obj[key], "YYYY/MM/DD");
        const endDate = dayjs(obj[endDateKey], "YYYY/MM/DD");
        const oneYearTwoMonthsLater = birthday.add(1, "year").add(2, "months");

        if (
          obj[papaMamaPlusKey] === "1" &&
          !oneYearTwoMonthsLater.isAfter(endDate)
        ) {
          checkResult = true;
        }
      }
    });
  });
  return checkResult;
}

// 同一の育児休業２重登録チェック
function checkDoubleChildcareLeave(inputDataList: any[]): boolean {
  let checkResult = false;
  inputDataList.forEach((obj1, index1) => {
    inputDataList.forEach((obj2, index2) => {
      if (index2 > index1) {
        const birthday1 = dayjs(obj1[`birthday`], "YYYY/MM/DD");
        const birthday2 = dayjs(obj2[`birthday`], "YYYY/MM/DD");
        const startDate1 = dayjs(obj1[`startDate`], "YYYY/MM/DD");
        const startDate2 = dayjs(obj2[`startDate`], "YYYY/MM/DD");
        const endDate1 = dayjs(obj1[`endDate`], "YYYY/MM/DD");
        const endDate2 = dayjs(obj2[`endDate`], "YYYY/MM/DD");

        if (
          birthday1.isSame(birthday2) &&
          ((!startDate2.isAfter(startDate1) && !startDate1.isAfter(endDate2)) ||
            (!startDate1.isAfter(startDate2) && !startDate2.isAfter(endDate1)))
        ) {
          checkResult = true;
        }
      }
    });
  });
  return checkResult;
}

// 同一の子について「産後パパ育休」を３回以上登録チェック
function checkSameChildPapaChildcareLeaveThreeOrMoreTimes(
  inputDataList: any[]
): boolean {
  const countMap: { [key: string]: number } = {};
  inputDataList.forEach((obj) => {
    if (obj[`papaChildcareLeaveFlg`] && obj[`papaChildcareLeaveFlg`] === "1") {
      countMap[obj[`birthday`]] = (countMap[obj[`birthday`]] || 0) + 1;
    }
  });
  return Object.values(countMap).some((count) => count >= 3);
}

// 産後パパ育休は子の出生日から８週間（５６日）を超えて終了日チェック
function checkPapaChildcareLeaveExceedsEightWeeksFromBirthday(
  inputDataList: any[]
): boolean {
  let checkResult = false;
  inputDataList.forEach((obj) => {
    if (obj[`papaChildcareLeaveFlg`] && obj[`papaChildcareLeaveFlg`] === "1") {
      if (
        dayjs(obj[`endDate`], "YYYY/MM/DD").isAfter(
          dayjs(obj[`birthday`], "YYYY/MM/DD").add(56, "day")
        )
      ) {
        checkResult = true;
      }
    }
  });
  return checkResult;
}

// 同一の子について「産後パパ育休」を４週間（２８日）を超えるチェック
function checkSameChildPapaChildcareLeaveExceedsForWeeks(
  inputDataList: any[]
): boolean {
  const countMap: { [key: string]: number } = {};
  inputDataList.forEach((obj, index) => {
    if (obj[`papaChildcareLeaveFlg`] && obj[`papaChildcareLeaveFlg`] === "1") {
      countMap[obj[`birthday`]] =
        (countMap[obj[`birthday`]] || 0) +
        dayjs(obj[`endDate`], "YYYY/MM/DD").diff(
          dayjs(obj[`startDate`], "YYYY/MM/DD"),
          "day"
        );
    }
  });
  return Object.values(countMap).some((count) => count > 28);
}

// 女性で、育児休業開始日が出産日の「8週間後+１日」(57日)よりも前の日付で入力されているチェック
function checkStartDateEarlierThanFiftySevenDaysFromBirthday(
  inputDataList: any[],
  sex: string | undefined
): boolean {
  let checkResult = false;
  inputDataList.forEach((obj) => {
    Object.keys(obj).forEach((key) => {
      if (key.startsWith("birthday") && obj[key]) {
        const startDateKey = `startDate`;

        const birthday = dayjs(obj[key], "YYYY/MM/DD");
        const startDate = dayjs(obj[startDateKey], "YYYY/MM/DD");
        const fiftySevenDaysLater = birthday.add(57, "day");

        if (sex === SexFlug["女"] && startDate.isBefore(fiftySevenDaysLater)) {
          checkResult = true;
        }
      }
    });
  });
  return checkResult;
}

// 第１子の育児休職期間に第２子の産休が開始される確認
function checkOverlapPeriodWithOtherChild(inputDataList: any[]): boolean {
  let checkResult = false;
  inputDataList.forEach((obj1, index1) => {
    inputDataList.forEach((obj2, index2) => {
      if (index2 > index1) {
        const birthday1 = dayjs(obj1[`birthday`], "YYYY/MM/DD");
        const birthday2 = dayjs(obj2[`birthday`], "YYYY/MM/DD");
        const startDate1 = dayjs(obj1[`startDate`], "YYYY/MM/DD");
        const startDate2 = dayjs(obj2[`startDate`], "YYYY/MM/DD");
        const endDate1 = dayjs(obj1[`endDate`], "YYYY/MM/DD");
        const endDate2 = dayjs(obj2[`endDate`], "YYYY/MM/DD");

        if (
          !birthday1.isSame(birthday2) &&
          ((!startDate2.isAfter(startDate1) && !startDate1.isAfter(endDate2)) ||
            (!startDate1.isAfter(startDate2) && !startDate2.isAfter(endDate1)))
        ) {
          checkResult = true;
        }
      }
    });
  });
  return checkResult;
}

// 入出力項目.育児休業終了（予定）日 ＜ 入出力項目.出生日確認
function checkEndDateBeforeBirthday(inputDataList: any[]): boolean {
  let checkResult = false;
  for (let idx = 0; idx < inputDataList.length; idx++) {
    const item = inputDataList?.[idx];
    if (checkResult || !item) {
      break;
    }
    if (!item?.endDate || !item?.birthday) {
      continue;
    }
    const endDate = dayjs(item?.endDate);
    const birthday = dayjs(item?.birthday);
    if (endDate?.isBefore?.(birthday)) {
      checkResult = true;
    }
  }
  return checkResult;
}

// 入出力項目.育児休業終了（予定）日 ＜ 入出力項目.育児休業開始日確認
function checkEndDateBeforeStartDate(inputDataList: any[]): boolean {
  let checkResult = false;
  for (let idx = 0; idx < inputDataList.length; idx++) {
    const item = inputDataList?.[idx];
    if (checkResult || !item) {
      break;
    }
    if (!item?.endDate || !item?.birthday) {
      continue;
    }
    const endDate = dayjs(item?.endDate);
    const startDate = dayjs(item?.startDate);
    if (endDate?.isBefore?.(startDate)) {
      checkResult = true;
    }
  }
  return checkResult;
}

export {
  requiredCheckError,
  checkBirthdayLaterThanRetireDate,
  checkEndDateLaterThanRetireDate,
  checkFutureBirthDate,
  checkStartDateBeforeContractDate,
  checkNoReasonPapaMamaPlusNotSelectedOneYearAfterBirthday,
  checkHasReasonEndDateTwoYearsLaterAfterBirthday,
  checkHasPapaMamaPlusEndDateOneYearTwoMonthsLaterAfterBirthday,
  checkDoubleChildcareLeave,
  checkSameChildPapaChildcareLeaveThreeOrMoreTimes,
  checkPapaChildcareLeaveExceedsEightWeeksFromBirthday,
  checkSameChildPapaChildcareLeaveExceedsForWeeks,
  checkStartDateEarlierThanFiftySevenDaysFromBirthday,
  checkOverlapPeriodWithOtherChild,
  checkEndDateBeforeBirthday,
  checkEndDateBeforeStartDate,
};
